"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEditCreditSection = void 0;

var _react = require("react");

var _mocks = require("../../mocks");

var _constants = require("../../constants");

var _utils = require("../../utils");

var _services = require("../../services");

const MAX = _mocks.CreditRangeByProduct[_constants.ProductTypes.HOME].max;

const useEditCreditSection = ({
  intendedCredit,
  productType,
  onInputChange
}) => {
  const inputRef = (0, _react.useRef)(null);
  const [viewMode, setViewMode] = (0, _react.useState)(true);
  const [value, setValue] = (0, _react.useState)(intendedCredit);
  const inputPlaceholder = (0, _react.useMemo)(() => {
    var _CreditRangeByProduct;

    return (0, _utils.formatPlainNumber)((_CreditRangeByProduct = _mocks.CreditRangeByProduct[productType]) == null ? void 0 : _CreditRangeByProduct.min);
  }, [productType]);

  const onValueChange = ({
    target
  }) => {
    const creditValue = (0, _utils.getOnlyNumbers)(target.value);

    if (creditValue <= MAX) {
      setValue(creditValue);
    }
  };

  const onToggleClick = () => {
    if (!viewMode) {
      onInputChange(value);
      (0, _services.dispatchInputValueChangeEvent)(value);
    }

    setViewMode(v => !v);
  };

  return {
    inputRef,
    viewMode,
    onValueChange,
    onToggleClick,
    inputPlaceholder,
    intendedCredit: value
  };
};

exports.useEditCreditSection = useEditCreditSection;